"use strict";

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getDeserializedFilters = exports.getSerializedFilters = void 0;

var filters_1 = __importDefault(require("../services/filters"));

exports.getSerializedFilters = function (filters) {
  var getSerializedValue = function getSerializedValue(_ref) {
    var type = _ref.type,
        value = _ref.value;

    if (type === 'date') {
      if (Array.isArray(value)) {
        return value.map(function (date) {
          return date.toISOString();
        });
      }

      return value.toISOString();
    }

    return value;
  };

  return filters.filter(function (filter) {
    return filter.value !== undefined && filter.value !== null;
  }).map(function (filter) {
    return {
      name: filter.column,
      type: filter.type,
      operation: filter.operation,
      value: getSerializedValue(filter),
      notNull: filter.notNull
    };
  });
};

exports.getDeserializedFilters = function (filters, fields, dataset) {
  return __awaiter(void 0, void 0, void 0,
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee() {
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!(!filters || !Array.isArray(filters) || filters.length === 0)) {
              _context.next = 2;
              break;
            }

            return _context.abrupt("return", []);

          case 2:
            _context.next = 4;
            return filters_1["default"].getDeserializedFilters(filters, fields, dataset);

          case 4:
            return _context.abrupt("return", _context.sent);

          case 5:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
};